const MODE_PRODUCTION = true;

const domain = window.location.hostname;

let BRAND_NAME;

switch (domain) {
    case "localhost":
        BRAND_NAME = "staging";
        break;

    case "member.excotrades.com":
    case "memberstg.excotrades.com":
        BRAND_NAME = "excotrades";
        break;

    case "member.ridgewaymarkets.com":
    case "member.ridgewaymarkets.net":
    case "memberstg.ridgewaymarkets.com":
        BRAND_NAME = "ridgewaymarkets";
        break;

    case "member.alliumtrades.com":
    case "memberstg.alliumtrades.com":
        BRAND_NAME = "alliumtrades";
        break;

    case "member.metapromarkets.com":
    case "member.metapromarkets.net":
    case "memberstg.metapromarkets.com":
        BRAND_NAME = "metapromarkets";
        break;

    case "member.fundamarkets.com":
    case "member.fundamarkets.net":
    case "memberstg.fundamarkets.com":
    case "memberstg.fundamarkets.net":
        BRAND_NAME = "fundamarkets";
        break;

    case "member.minosfutures.com":
    case "memberstg.minosfutures.com":
    case "member.minosbrokers.com":
    case "memberstg.minosbrokers.com":
    case "member.minosbrokers.net":
    case "memberstg.minosbrokers.net":
        BRAND_NAME = "minosmarkets";
        break;

    case "member.cronoscap.com":
    case "member.cronoscap.net":
    case "memberstg.cronoscap.com":
    case "memberstg.cronoscap.net":
        BRAND_NAME = "cronoscap";
        break;

    case "member.qvmarkets.com":
    case "memberstg.qvmarkets.com":
        BRAND_NAME = "quorvex";
        break;

    case "member.blueocex.com":
    case "member.blueoceanfin.com":
    case "member.tradewithblueocean.com":
        BRAND_NAME = "blueocean";
        break;

    case "member.antospnc.com":
    case "member.antos.io":
    case "memberstg.antos.io":
        BRAND_NAME = "antos";
        break;

    case "member.antospnc.ai":
    case "memberstg.antospnc.ai":
    case "member.antospnc.asia":
        BRAND_NAME = "antospnc";
        break;

    case "member.dearc.ai":
        BRAND_NAME = "dearc";
        break;

    case "member.pxmarkets.ai":
    case "memberstg.pxmarkets.ai":
        BRAND_NAME = "pxmarkets";
        break;

    // Internal DEV environment — backend at admin.worthycodes.com.
    case "member.worthycodes.com":
        BRAND_NAME = "worthycodes";
        break;
}

export { BRAND_NAME, MODE_PRODUCTION };
